import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { publicApi, useApi } from "@/lib/api";

const Ctx = createContext({ me: null, meta: { categories: [], conditions: [], cities: [] }, refreshMe: () => {}, favIds: new Set(), toggleFav: async () => {} });

export function MeProvider({ children }) {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [meta, setMeta] = useState({ categories: [], conditions: [], cities: [] });
  const [favIds, setFavIds] = useState(new Set());

  const loadFavs = useCallback(async () => {
    if (!isSignedIn) return setFavIds(new Set());
    try {
      const { data } = await api.get("/me/favorites");
      setFavIds(new Set(data.map((l) => l.id)));
    } catch {}
  }, [api, isSignedIn]);

  const toggleFav = useCallback(async (id) => {
    const on = favIds.has(id);
    await (on ? api.delete(`/listings/${id}/favorite`) : api.post(`/listings/${id}/favorite`));
    setFavIds((s) => { const n = new Set(s); on ? n.delete(id) : n.add(id); return n; });
    return !on;
  }, [api, favIds]);

  const refreshMe = useCallback(async () => {
    if (!isSignedIn) return setMe(null);
    try {
      const { data } = await api.get("/me");
      setMe(data);
    } catch {
      setMe(null);
    }
  }, [api, isSignedIn]);

  useEffect(() => {
    if (isLoaded) {
      refreshMe();
      loadFavs();
    }
  }, [isLoaded, refreshMe, loadFavs]);

  useEffect(() => {
    publicApi.get("/meta").then((r) => setMeta(r.data));
  }, []);

  return <Ctx.Provider value={{ me, meta, refreshMe, favIds, toggleFav }}>{children}</Ctx.Provider>;
}

export const useMe = () => useContext(Ctx);
